export default __webpack_public_path__ + "static/media/arrow-right.50080309.svg";